export const categoryIconMap = {};
